<div [ngClass]="{'form-group': showLabel}">
  <wm-de-label
    [entity]="entity"
    [for]="entity.templateCode"
    [displayOnly]="true"
    *ngIf="showLabel"
  ></wm-de-label>
  <ul class="list-group">
    <a
      *ngFor="let d of entity.documents; let idx = index"
      class="list-group-item"
      [href]="d.path"
      target="_blank"
      [ngClass]="{
        'link-color': templateForPermitForm,
      }"
    >
      {{ d.name }}
    </a>
  </ul>
</div>
